var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C11.9016 11 14.25 8.65156 14.25 5.75C14.25 2.84844 11.9016 0.5 9 0.5C6.09844 0.5 3.75 2.84844 3.75 5.75C3.75 8.65156 6.09844 11 9 11ZM12.6 12.5H12.2109C11.2359 12.9688 10.1531 13.25 9 13.25C7.84688 13.25 6.76875 12.9688 5.78906 12.5H5.4C2.41875 12.5 0 14.9188 0 17.9V19.25C0 20.4922 1.00781 21.5 2.25 21.5H15.75C16.9922 21.5 18 20.4922 18 19.25V17.9C18 14.9188 15.5812 12.5 12.6 12.5ZM22.5 11C24.9844 11 27 8.98438 27 6.5C27 4.01562 24.9844 2 22.5 2C20.0156 2 18 4.01562 18 6.5C18 8.98438 20.0156 11 22.5 11ZM24.75 12.5H24.5719C23.9203 12.725 23.2313 12.875 22.5 12.875C21.7687 12.875 21.0797 12.725 20.4281 12.5H20.25C19.2938 12.5 18.4125 12.7766 17.6391 13.2219C18.7828 14.4547 19.5 16.0906 19.5 17.9V19.7C19.5 19.8031 19.4766 19.9016 19.4719 20H27.75C28.9922 20 30 18.9922 30 17.75C30 14.8484 27.6516 12.5 24.75 12.5Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFriends);
export default __webpack_public_path__ + "static/media/menu-friends.4c51f835e98c8c9d24b243f4b2b6bdd4.svg";
export { ForwardRef as ReactComponent };